<template>
  <div class="patrol-panel">
    <ioc-form ref="form"
              v-model="ruleForm"
              :option="optionForm"
              @submit="submitForm"
              @reset-change="handleClose">
      <!-- start @description: 表单-布控类型 !-->
      <template slot-scope="scope"
                slot="type">
        <div prop="type">
          <el-radio-group v-model="listType"
                          @change="selectGroupList(scope)">
            <el-radio :label="3"
                      :disabled="alarmTypeDisabledUpdate">
              {{$t('personCm.label.whiteList')}}
            </el-radio>
            <el-radio :label="2"
                      :disabled="alarmTypeDisabledUpdate">
              {{$t('personCm.label.blackList')}}
            </el-radio>
          </el-radio-group>
        </div>
      </template>
      <!-- start @description: 表单-报警类型按钮 !-->
      <template slot-scope="scope"
                slot="hitType">
        <div prop="hitType">
          <el-radio-group v-model="ruleForm.hitType"
                          @change="selecthitType(scope)">
            <el-radio :label="1"
                      :disabled="alarmTypeDisabled">
              {{$t('personCm.label.hitAlarm')}}
            </el-radio>
            <el-radio :label="2"
                      :disabled="!alarmTypeDisabled">
              {{$t('personCm.label.nohitAlarm')}}
            </el-radio>
          </el-radio-group>
        </div>
      </template>
      <!-- start @description: 表单-黑名单组按钮 !-->
      <template slot-scope="scope"
                slot="faceGroup">
        <div class="rel">
          <el-input disabled
                    v-model="ruleForm.faceGroup"
                    class="abs">
            {{scope}}
          </el-input>
          <a href="javascript:;"
             class="abs pl10 pr5 mr20 r0"
             @click="openBlackGroup(ruleForm.type)">
            <span>{{$t('personCm.label.select')}}</span>
          </a>
        </div>
      </template>
      <!-- start @description: 表单-布控时段按钮 !-->
      <template slot-scope="scope"
                slot="timeList">
        <div class="rel">
          <el-input disabled
                    v-model="ruleForm.timeSlotText"
                    class="abs">
            {{scope}}
          </el-input>
          <a href="javascript:;"
             class="abs pl10 pr5 mr20 r0"
             @click="openTimeList">
            <span>{{$t('personCm.label.select')}}</span>
          </a>
        </div>
      </template>
    </ioc-form>
    <!-- 布控时段选择弹窗 -->
    <el-dialog :title="$t('personCm.title.selectTime')"
               :visible.sync="controlWindowShow"
               v-dialogDrag
               :modal="false"
               width="1200px">
      <app-calendar-range ref="appCalendarRange"
                          :isNeedFooter="true"
                          @close="close"
                          @getDate="getDate" />
    </el-dialog>
    <!-- 人员名单组列表 -->
    <face-group-search ref="blackgroup"
                       @selectBlackList="selectBlackList">
    </face-group-search>
  </div>
</template>
<script>
import { optionForm } from '../options/createColumn'
import { Data, Log, Dates } from '$utils'

export default {
  components: {
    // 人员名单组列表
    FaceGroupSearch: () => import('./FaceGroupSearch'),
    // 日期范围面板组件
    AppCalendarRange: () => import('@src/components/business/app-calendar-range')
  },
  data() {
    return {
      listType: '', // 2：黑名单  3：白名单
      alarmTypeDisabled: '', // 告警类型禁用
      formData: {},
      // 创建/修改布控的数据
      ruleForm: {
        // 布控名称
        name: '',
        // 布控阈值
        confidenceThreshold: 50,
        // 布控类型
        type: '',
        // 报警类型
        hitType: '',
        // 布控人员名单组 后台
        groupList: [],
        // 回填人员名单组 回显
        faceGroup: '',
        // 布控摄像机组
        bayonetList: '',
        // 布控时段时间组件
        timeList: [],
        // 布控开始时间
        startDate: '',
        // 布控结束时间
        endDate: '',
        // 布控时间段回显
        timeSlotText: ''
      },
      // 表单的配置
      optionForm: {
        //让自带的提交和清空按钮隐藏
        submitPosition: 'center',
        size: 'mini',
        submitText: '',
        emptyText: '',
        labelPosition: 'right',
        span: 12,
        clearable: true,
        menuBtn: true,
        column: optionForm()
      },
      controlWindowShow: false
    }
  },
  computed: {
    alarmTypeDisabledUpdate() {
      return this.$route.path === '/personControl/edit' ? true : false
    },
    appCalendarRange() {
      return this.$refs['appCalendarRange']
    }
  },
  watch: {
    appCalendarRange(newValue, oldValue) {
      console.log(newValue)
    },
    listType(newValue, oldValue) {
      this.ruleForm.faceGroup = ''
      this.ruleForm.groupList = []
      this.ruleForm.type = newValue
      if (newValue === 2) {
        this.ruleForm.hitType = 1
        this.alarmTypeDisabled = false
      } else {
        this.alarmTypeDisabled = true
        this.ruleForm.hitType = 2
      }
    }
  },
  mounted() {
    this.optionForm.submitText = this.$t('personCm.button.save')
    this.optionForm.emptyText = this.$t('personCm.button.cancel')
  },
  methods: {
    // 拿到子组件回传的日期段
    getDate(val) {
      console.log('outer>>>>>>', val)
      if (val.dates && val.dates.length) {
        this.ruleForm.startDate = Dates.format(val.dates[0], 'yyyy-MM-dd')
        this.ruleForm.endDate = Dates.format(val.dates[1], 'yyyy-MM-dd')
        this.ruleForm.timeSlotText =
          Dates.format(val.dates[0], 'yyyy-MM-dd') +
          ' ' +
          this.$t('personCm.title.to') +
          ' ' +
          Dates.format(val.dates[1], 'yyyy-MM-dd')
        this.ruleForm.timeList = val.resData
      }
    },
    loadData(data) {
      console.log('修改需要回填的数据', data)
      this.optionForm.submitText = this.$t('personCm.button.save')
      this.formData = data
      this.ruleForm = Data.adapter(
        this.formData,
        {
          name: 'name',
          confidenceThreshold: 'confidenceThreshold',
          hitType: 'hitType',
          type: 'type'
        },
        true
      )
      this.ruleForm.startDate = data.startDate
      this.ruleForm.endDate = data.endDate
      this.ruleForm.confidenceThreshold = data.confidenceThreshold
      this.ruleForm.hitType = data.hitType
      this.listType = data.type
      let arr = []
      let arrName = []
      data.groupList.forEach(item => {
        arr.push({
          repositoriesCode: item.repositoriesCode
        })
        arrName.push(item.repositoriesName)
      })
      this.$nextTick(() => {
        this.ruleForm.groupList = arr
        this.ruleForm.faceGroup = arrName.join(',')
        console.log(this.ruleForm.faceGroup)
      })
      this.formData.groupList = data.groupList
      this.ruleForm.timeList = data.timeList
      this.ruleForm.code = data.code
      //   时间段回填
      this.ruleForm.timeSlotText =
        data.startDate +
        ' ' +
        this.$t('personCm.title.to') +
        ' ' + data.endDate
    },
    // 日期段
    // calendarChange(item) {
    //   console.info('日期段', item)
    // },
    // 选择黑名单组
    selectBlackList(params) {
      //   console.log('传递过来的黑名单组', params)
      let name = []
      this.ruleForm.groupList.length = 0
      params.forEach(item => {
        name.push(item.name)
        this.ruleForm.groupList.push({
          repositoriesCode: item.code
        })
      })
      this.ruleForm.faceGroup = name.toString()
    },
    // 打开黑名单组
    openBlackGroup(params) {
      if (!this.listType) {
        this.$message.warning(this.$t('personCm.message.choseType'))
        return false
      }
      this.$refs.blackgroup.dialogTableBlackList = true
      this.$refs.blackgroup.getNameListGroup(params)
    },
    // 选择布控时间段
    openTimeList() {
      this.controlWindowShow = true
      let dataList = {}
      console.log(this.formData.timeList, '>>>>>>>>>>>>>>>>')
      const timeList = this.formData.timeList
      if (timeList && timeList.length) {
        this.formData.timeList.map(item => {
          item.dayType = item.day
          item.startTime = item.startTime.replace(/\:/g, '') // eslint-disable-line
          item.endTime = item.endTime.replace(/\:/g, '') // eslint-disable-line
          delete item.day
          return item
        })
        this.$nextTick(() => {
          this.$refs.appCalendarRange.setData(this.formData.timeList, [
            this.formData.startDate,
            this.formData.endDate
          ])
        })
      }
    },
    /*
     *@name:提交功能
     *@param:{type}
     *@description:
     *@return:
     *@author: zhengff
     *@date: 2019-04-30 18:04:39
     */
    submitForm() {
      console.log('提交布控表单', this.ruleForm)
      this.$emit('submit', this.ruleForm)
    },
    /*
     *@name:取消-返回到布控列表页面
     *@param:{type}
     *@description:返回到布控列表页面
     *@return:无
     *@author: zhengff
     *@date: 2019-05-02 22:06:00
     */
    handleClose() {
      this.$router.push({
        path: '/personControl/manage',
        name: 'controManage'
      })
    },
    // 选择布控类型
    selectGroupList(param) {
      // console.log(param.value)
      // //   2 黑名单 3 白名单
      // if (this.ruleForm.hitType == 1 && this.ruleForm.type == 3) {
      //   this.$message({
      //     showClose: true,
      //     message: '选择命中告警必须选择黑名单',
      //     type: 'warning'
      //   })
      //   this.ruleForm.type = ''
      // }
      // if (this.ruleForm.hitType == 2 && this.ruleForm.type == 2) {
      //   this.$message({
      //     showClose: true,
      //     message: '选择非命中告警必须选择白名单',
      //     type: 'warning'
      //   })
      //   this.ruleForm.type = ''
      // }
    },
    // 选择报警类型
    selecthitType(param) {
      // console.log(param.value)
      // //   1 命中 2  非命中
      // //   2 黑名单 3 白名单
      // if (this.ruleForm.type == 2 && this.ruleForm.hitType == 2) {
      //   this.$message({
      //     showClose: true,
      //     message: '选择黑名单必须选择命中告警',
      //     type: 'warning'
      //   })
      //   this.ruleForm.hitType = ''
      // }
      // if (this.ruleForm.type == 3 && this.ruleForm.hitType == 1) {
      //   this.$message({
      //     showClose: true,
      //     message: '选择白名单必须选择非命中告警',
      //     type: 'warning'
      //   })
      //   this.ruleForm.hitType = ''
      // }
    },
    //关闭时间组件
    close() {
      console.log('关闭时间组件----------------------')
      this.controlWindowShow = false
    }
  }
}
</script>

<style lang="scss">
.patrol-panel {
  .abs {
    .el-input__inner {
      padding-right: 56px;
    }
  }
  .calendar-range .pl30 .el-date-editor{width: 510px;}
}
</style>
